// extracted by mini-css-extract-plugin
export default {"MenuContainer":"lKQ4tEMC","Menu":"JkrSktpP","Item":"OxmHJROg","Group":"P8cSEW8D","ComponentItem":"hmIEtYuY","DisabledItem":"YJtyHYx8","header":"rg776Fi5"};